export default {
    'name': 'twitter',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M17.2033 3.875H19.9599L13.9374 10.7583L21.0224 20.125H15.4749L11.1299 14.4442L6.15826 20.125H3.39992L9.84159 12.7625L3.04492 3.875H8.73326L12.6608 9.0675L17.2033 3.875ZM16.2358 18.475H17.7633L7.90326 5.43833H6.26409L16.2358 18.475Z\' fill=\'#026958\'/>'
}
